import React, { FC, useState } from 'react'
import { Menu } from 'antd'
import { withRouter, RouteComponentProps } from 'react-router-dom'
import { maxBy, first } from 'lodash'
import { useHistory, useLocation } from 'react-router'
import { useMount } from 'react-use'
import { checkIsLogin } from './service'
import { headerMenus } from '../app-bar/const'
import { MenuProps } from './interface'

import './index.less'

const getMatchRouteUrl = (url) => {
  if (!url) return ''
  const u = url.startsWith('/') || url.startsWith('http') ? url : `/${url}`
  return u.toUpperCase()
}

const getCurrentMenu = (href, menus: MenuProps[]) => {
  if (href === '/') {
    return ({
      selectedKeys: [],
      openKeys: []
    })
  }
  const hash = getMatchRouteUrl(href)
  const mathMenus = menus.filter(x => (
    x.menuUrl
      && hash.startsWith(getMatchRouteUrl(x.menuUrl))
  ))
  // 匹配最长路由
  const menu = maxBy(mathMenus, o => o.menuUrl.length)
  if (!menu) {
    return ({
      selectedKeys: [],
      openKeys: []
    })
  }
  const parent = menus.find(x => x.id === menu.pid)
  return ({
    selectedKeys: [menu.id].filter(Boolean),
    openKeys: parent ? [parent.id] : []
  })
}

const MenuList: FC<RouteComponentProps> = (props) => {
  const [menuList] = useState<MenuProps[]>(headerMenus)
  const [innerOpenKeys, setInnerOpenKeys] = useState<string[]>([])
  const history = useHistory()
  const location = useLocation()
  useMount(async () => {
    await checkIsLogin()
    if (location.pathname !== '/') return
    const firstMenu = first(menuList.filter(x => x.menuLevel === 0))
    const firstSubMenu = first(menuList.filter(x => x.pid === firstMenu?.id))
    firstSubMenu && history.push(firstSubMenu?.menuUrl)
  })
  const menus = menuList || []
  const { selectedKeys, openKeys } = getCurrentMenu(props.location.pathname, menus)

  const menuItems = () => {
    const curMenus = menus.filter(x => x.menuLevel === 0)
    return curMenus.map(menuLv1 => {
      return ({
        key: menuLv1.id,
        label: (
          <span onClick={() => menuLv1.menuUrl.startsWith('http') ? window.open(menuLv1.menuUrl) : history.push(menuLv1.menuUrl)}>
            {menuLv1.text}
          </span>),
        children: menus.filter(x => x.pid === menuLv1.id).map(menuLv2 => (
          {
            key: menuLv2.id,
            label: (
              <span onClick={() => menuLv2.menuUrl.startsWith('http') ? window.open(menuLv2.menuUrl) : history.push(menuLv2.menuUrl)}>
                {menuLv2.text}
              </span>),
          }
        ))
      })
    })
  }

  return (
    <Menu
      openKeys={openKeys.concat(innerOpenKeys)}
      onOpenChange={setInnerOpenKeys}
      onClick={(() => {
        setInnerOpenKeys([])
      })}
      selectedKeys={selectedKeys}
      mode="horizontal"
      items={menuItems()}
    />
  )
}

export default withRouter(MenuList)
